import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import orgTreeModal from "@/components/Modal/select-org-tree-modal.vue";
import request from "@/service/invites";
import Cookies from "js-cookie";
import InviteLinkDrawer from "./Modal/InviteLink-drawer.vue";
import InviteLink from "./Modal/InviteLink-Modal.vue";
export default {
  name: "InviteSetting",
  components: {
    "invite-link-drawer": InviteLinkDrawer,
    "invite-link": InviteLink,
    "org-tree-modal": orgTreeModal
  },
  data() {
    return {
      formRef: null,
      inviteForm: {
        validityType: 0,
        orgId: [],
        orgName: "",
        needApprove: "T",
        isInvalid: "F",
        inviteCode: null //邀请码
      },
      organizationTree: [],
      rules: {
        validityType: [{
          required: true,
          type: "number",
          message: $t("x7skfb7", "请选择有效期限"),
          trigger: "change"
        }],
        orgId: [{
          required: true,
          type: "array",
          message: $t("2ecyvd5", "请选择部门"),
          trigger: "change"
        }]
      },
      orgList: []
    };
  },
  computed: {
    inviteFormInfo() {
      return {
        ...this.inviteForm,
        orgList: this.orgList
      };
    },
    validityTypeList() {
      return [{
        label: $t("dzch7w4", "永久有效"),
        value: 4
      }, {
        label: "7" + $t("hm11", "天"),
        value: 0
      }, {
        label: "15" + $t("hm11", "天"),
        value: 1
      }, {
        label: "30" + $t("hm11", "天"),
        value: 2
      }, {
        label: "90" + $t("hm11", "天"),
        value: 3
      }];
    }
  },
  methods: {
    getData(data) {
      var _this$$refs$orgTreeMo;
      this.inviteForm.orgId = data.map(item => item.key);
      this.inviteForm.orgName = data.map(item => item.name).join(",");
      let res = (_this$$refs$orgTreeMo = this.$refs.orgTreeModalRef) === null || _this$$refs$orgTreeMo === void 0 ? void 0 : _this$$refs$orgTreeMo.getEntities(this.inviteForm.orgId, []);
      this.orgList = res;
    },
    changeDepartment() {
      var _this$$refs$orgTreeMo2;
      let {
        orgId
      } = this.inviteForm;
      let res = (_this$$refs$orgTreeMo2 = this.$refs.orgTreeModalRef) === null || _this$$refs$orgTreeMo2 === void 0 ? void 0 : _this$$refs$orgTreeMo2.getEntities(orgId, []);
      this.orgList = res;
      this.$refs.orgTreeModalRef.open(res);
    },
    openRecord() {
      this.$refs.inviteLinkDrawer.open();
    },
    editInviteLink(data) {
      let {
        inviteCode,
        orgName,
        isInvalid
      } = data;
      Object.assign(this.inviteForm, {
        inviteCode,
        orgName,
        isInvalid
      });
      this.$refs.inviteLinkModal.open(this.inviteForm);
    },
    clearInviteLink() {
      Object.assign(this.inviteForm, {
        inviteCode: null
      });
      this.$refs.inviteLinkModal.open();
    },
    checkInvite(item) {
      this.$emit("check", item);
    },
    submit() {
      this.$refs.formRef.validate(async valid => {
        if (valid) {
          let {
            validityType,
            orgId,
            needApprove
          } = this.inviteForm;
          let data = {
            validityType,
            orgId: orgId ? orgId.join(",") : "",
            needApprove,
            isInvalid: "F"
            // inviteCode
          };
          let res = await request.createInviteLink(data);
          let {
            retVal,
            result,
            msg
          } = res;
          if (result === 0) {
            this.$Message.success(msg);
            this.inviteForm = {
              ...retVal,
              orgId
            };
            this.$refs.inviteLinkModal.open();
            this.$refs.inviteLinkDrawer.open();
          }
        }
      });
    },
    reset() {
      this.$Modal.confirm({
        title: $t("ebs0aq7", "确定要重置吗？"),
        content: $t("dtti3ay", "全部重置后，您已生成的企业邀请链接及二维码都将失效，请确认是否重置？"),
        onOk: async () => {
          let {
            result,
            msg
          } = await request.resetInviteLink();
          if (result === 0) {
            this.$Message.success(msg);
            this.$refs.inviteLinkDrawer.clearInviteLink();
            // this.$refs.inviteLinkModal.hide();
          }
        }
      });
    },
    findPathByOrgTree(tree, targetId) {
      let path = [];
      if (!tree || tree.length === 0) return path;
      const findPath = (nodes, target) => {
        for (let node of nodes) {
          if (node.value === target) {
            path.unshift(node.value);
            return true;
          }
          if (node.children && node.children.length > 0) {
            if (findPath(node.children, target)) {
              path.unshift(node.value);
              return true;
            }
          }
        }
        return false;
      };
      findPath(tree, targetId);
      return path;
    },
    formateOrgTree(orgs) {
      if (!orgs) return [];
      return orgs.map(org => {
        let item = {
          value: org.orgId,
          label: org.name
        };
        if (org.children && org.children.length > 0) {
          item.children = this.formateOrgTree(org.children);
        }
        return item;
      });
    },
    async getOrganizationTree() {
      let res = await request.getOrganizationTreeTree();
      let {
        retVal: {
          department
        }
      } = res;
      this.organizationTree = this.formateOrgTree(department);
    },
    async getOrgDept() {
      let {
        retVal
      } = await request.getOrgDept({
        userId: Cookies.get("userId")
      });
      this.inviteForm.orgId = retVal;
      let res = this.$refs.orgTreeModalRef.getEntities(retVal, []);
      this.orgList = res;
    },
    async init() {
      await this.getOrganizationTree();
      Object.assign(this.inviteForm, {
        needApprove: "T",
        validityType: 0
      });
      await this.getOrgDept();
    }
  },
  async mounted() {
    await this.init();
  }
};